import React from "react";
import { Route, Routes } from "react-router-dom";

import MainPage from "../../Pages/Submitter/MainPage";
import MainResearcherInformainContainer from "../../Containers/MainResearcherInformainContainer";

import WorkPlanEstimatedBudget from "../../Containers/WorkPlanEstimatedBudget";

import Attachments from "../../Pages/Submitter/Attachments";

import ResearchProposalInformation from "../../Containers/ResearchProposalInformation";

import AttachmentsContainer from "../../Containers/AttachmentsContainer";
import ConflictOfInterestAndResearchEthics from "../../Containers/ConflictOfInterestAndResearchEthics";
import ReportStage from "../../Pages/Submitter/ReportStage";
import ReportStageForm from "../../ContainersReport/ReportStageForm";
import StagesTableContainers from "../../ContainersReport/StagesTableContainers";
import EmployeeTransfers from "../../ContainersReport/EmployeeTransfers";
import TransferRequestDetails from "../../Pages/Report/ProjectModificationRequests/TransferRequestDetails";
import ProjectExtensionRequestDetails from "../../Pages/Report/ProjectModificationRequests/ProjectExtensionRequestDetails";

export default function MainRoutesSubmitter() {
  return (
    <Routes>
      <Route path="/SRFund" element={<MainPage />} />

      <Route path="/SRFund/ReportStage" element={<ReportStage />} />

      <Route
        path="/SRFund/ReportStageForm/:reportId/:reportStageId"
        element={<ReportStageForm />}
      />
      <Route path="/SRFund/mainpage" element={<MainPage />} />

      <Route
        path="/SRFund/MainResearcherInformainContainer"
        element={<MainResearcherInformainContainer />}
      />
      <Route
        path="/SRFund/AttachmentsAndPledge"
        element={<AttachmentsContainer />}
      />

      <Route
        path="/SRFund/MainResearcherInformainContainer"
        element={<MainResearcherInformainContainer />}
      />
      {/* <Route path="/SRFund/Attachments" element={<Attachments />} /> */}

      <Route
        path="/SRFund/ResearchProposalInformation"
        element={<ResearchProposalInformation />}
      />
      <Route
        path="/SRFund/ConflictOfInterestAndResearchEthics"
        element={<ConflictOfInterestAndResearchEthics />}
      />

      <Route
        path="/SRFund/WorkPlanEstimatedBudget"
        element={<WorkPlanEstimatedBudget />}
      />

      <Route
          path="/SRFund/EmployeeTransfers/:reportId"
          element={<EmployeeTransfers  />}
        />

        <Route
          path="/SRFund/TransferRequestDetails/:reportId/:projectModificationRequestsId"
          element={<TransferRequestDetails />}
        />
        <Route
          path="/SRFund/ProjectExtensionRequestDetails/:reportId/:projectModificationRequestsId"
          element={<ProjectExtensionRequestDetails />}
        />
    </Routes>
  );
}
